export const SET_PORTAL = 'SET_PORTAL'
export const UPDATE_PORTAL_SUCCESS = 'UPDATE_PORTAL_SUCCESS'
export const CHANGE_PORTAL = 'CHANGE_PORTAL'
export const SET_INFO = 'SET_INFO'
export const ADD_GALLERY_IMAGE = 'ADD_GALLERY_IMAGE'
export const ADD_PROMOTION = 'ADD_PROMOTION'
export const REMOVE_PROMOTION = 'REMOVE_PROMOTION'
export const ADD_LINK = 'ADD_LINK'
export const ADD_LINK_IMAGE = 'ADD_LINK_IMAGE'
export const REMOVE_LINK  = 'REMOVE_LINK'
export const REMOVE_IMAGE_LIST_ITEM = 'REMOVE_IMAGE_LIST_ITEM'


// WEBPACK FOOTER //
// ./src/constants/index.js